export const decimalNumberRegex = /^(0[.,]\d+|[1-9]\d*([.,]\d*)?)$/;
